//src/Components/EmojiPicker/Emoji.tsx
import { useCallback, useContext } from 'react';
import { EmojiData, EmojiName } from '.';
import { PreviewEmojiContext, SelectEmojiContext } from './contexts';
import { Emojis } from './data';

export default function Emoji({ emoji }: { emoji: EmojiData }) {
  const { selectEmoji } = useContext(SelectEmojiContext);
  const { setPreview } = useContext(PreviewEmojiContext);
  const handleMouseEnter = useCallback(() => setPreview(emoji), []);
  const handleMouseLeave = useCallback(() => setPreview(undefined), []);
  const handleOnClick = useCallback(() => selectEmoji(emoji), []);

  return (
    <button
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className="p-1 text-lg"
      key={emoji.id}
      onClick={handleOnClick}
    >
      {Emojis.emojis[emoji.id as EmojiName].skins[0].native}
    </button>
  );
}
